<template>
	<div class="client-switcher-box">

		<button class="chosen-client" @click.stop.prevent="toggleShowContent">
			<span class="text">{{ $store.state.auth.chosenClient.name }}</span>
			<i class="fa-light fa-angle-down" v-if="clientOptions.length"></i>
		</button>
		<div class="client-switcher-content" v-if="showContent && clientOptions.length">
			<p class="choose-client-text">{{ $t('general.choose_client') }}</p>
			<ul class="clients-list" v-if="clientOptions.length">
				<li v-for="item in clientOptions" :key="item.intranet_id">
					<button class="chose-client" @click.prevent="chooseClient(item)">
						<span class="icon">
							<i class="fa-light fa-user"></i>
						</span>
						<span class="text">{{ item.name }}</span>
					</button>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
export default {
	name: "ClientSwitcherBox",
	data() {
		return {
			showContent: false,
		}
	},
	computed: {
		clientOptions() {
			let options = [];

			options.push({
				name: this.$store.state.auth.user.full_name,
				intranet_id: this.$store.state.auth.user.intranet_id?.length ? this.$store.state.auth.user.intranet_id[0].intranet_id : '',
				alliance: this.$store.state.auth.user.intranet_id?.length ? this.$store.state.auth.user.intranet_id[0].alliance : this.$store.state.auth.user.alliance,
			});

			if (this.$store.state.auth?.user?.relations) {
				this.$store.state.auth.user.relations.forEach(relation => {
					let name = [relation.first_name, relation.last_name];
					options.push({
						name: name.join(' '),
						intranet_id: relation.id,
						alliance: relation.alliance,
					});
				});
			}

			options = options.filter((option) => {
				const chosen = this.$store.state.auth.chosenClient;
				return !(
					option.intranet_id === chosen.intranet_id &&
					option.alliance === chosen.alliance
				);
			});

			return options;
		}
	},
	methods: {
		toggleShowContent() {
			this.showContent = !this.showContent;
		},
		hideShowContent() {
			this.showContent = false;
		},
		chooseClient(data) {
			this.$store.dispatch('chooseClient', {
				chosenClient: data,
				reload: true,
			});
			this.showContent = false;
		},
		handleSwitchClient(intranetId) {
			let client = this.clientOptions.find((client) => client.intranet_id === intranetId);
			if (!client) {
				return;
			}

			this.chooseClient(client);
		}
	},

	created() {
		document.body.addEventListener('click', this.hideShowContent);
		this.$root.$on('switch-client', this.handleSwitchClient);
	},
	beforeDestroy() {
		document.body.removeEventListener('click', this.hideShowContent);
		this.$root.$off('switch-client');
	}

}
</script>

<style scoped lang="scss">
.light-mode {
	.chosen-client {
		color: var(--background-color, $backgroundColor);
	}

	.client-switcher-box {
		.client-switcher-content {
			background: #F0F0F2;
		}
	}

	.chose-client {
		color: var(--background-color, $backgroundColor);

		.icon {
			color: var(--background-color, $backgroundColor);
			border-color: var(--background-color, $backgroundColor);
		}
	}

	.clients-list {
		border-top: 1px solid transparentize($backgroundColor, .8);
	}
}

.user-nav.native {
	.client-switcher-box {
		.client-switcher-content {
			right: auto;
			left: 0;
		}
	}

	.chosen-client {
		font-size: 14px;
		max-width: 100%;
		width: 100%;

		.text {
			max-width: calc(100% - 5px);
			text-overflow: ellipsis;
			overflow: hidden;
			display: inline-block;
		}
	}
}

.client-switcher-box {
	position: relative;

	.client-switcher-content {
		position: absolute;
		right: 0;
		top: calc(100% + 10px);
		background: #0e1b34;
		padding: 15px 20px;
		white-space: nowrap;
		border-radius: 7px;
		font-size: 14px;
		z-index: 10;

	}

	.profile-link {
		color: var(--white-color, $whiteColor);
		display: flex;
		align-items: center;

		&:hover {
			color: var(--primary-color, $primaryColor);
		}

		.icon {
			margin-right: 15px;
			text-align: center;
			display: flex;
			width: 25px;
			align-items: center;
			justify-content: center;
			opacity: .3;
			font-size: 20px;
			color: var(--white-color, $primaryColor);
		}
	}

}

.choose-client-text {
	text-align: center;
	margin-bottom: 0;
}

.chosen-client {
	border: none;
	background: transparent;
	color: var(--white-color, $whiteColor);
	transition: $animationDefaultDuration;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: flex;
	align-items: center;

	i {
		margin-left: 5px;
	}

	&:has(i) {
		cursor: pointer;

		&:hover {
			color: var(--primary-color, $primaryColor);
		}
	}

	> .text {
		max-width: 220px;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.clients-list {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px solid transparentize($whiteColor, .8);

	li {
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 0;
		}
	}
}

.chose-client {
	border: none;
	background: transparent;
	color: var(--white-color, $whiteColor);
	display: flex;
	align-items: center;
	transition: $animationDefaultDuration;
	cursor: pointer;
	max-width: 220px;

	.text {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;


	}

	.icon {
		color: var(--white-color, $whiteColor);
		width: 25px;
		min-width: 25px;
		height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		border: 1px solid var(--white-color, $whiteColor);
		opacity: .3;
		margin-right: 15px;
	}

	&:hover {
		color: var(--primary-color, $primaryColor);
	}

}
</style>